'use client';

// imports
import { useAtom } from 'jotai';

// lib files
import { appSignInAtom } from '@/lib/atoms/app-sign-in';
import { DeviceType } from '@/lib/constants';
import { getDeviceName } from '@/app/(app-sign-in)/tv/helpers';
import { getPassportLearnMoreUrl } from '@/lib/helpers/get-passport-learn-more-url';
import { StationData } from "@/lib/types/api/stations-data";

// components
import PassportLockup from '@/components/PassportLearnMore/PassportLockup/PassportLockup';
import PassportPrompt from '@/components/PassportPrompt/PassportPrompt';

// styles
import styles from './AppSignInSuccess.module.scss';

interface AppSignInSuccessProps {
  stationData?: StationData;
}

const AppSignInSuccess = (props: AppSignInSuccessProps) => {
  const { stationData } = props;
  const [ appSignInState ] = useAtom(appSignInAtom);
  const stationName = appSignInState.stationShortCommonName || 'PBS';
  const deviceName = appSignInState.deviceType && getDeviceName(appSignInState.deviceType);
  const passportLearnMoreUrl = getPassportLearnMoreUrl(stationData);

  // @TODO if other platforms get in app donations,
  // update this list
  const PlatformsWithInAppDonation = [
    'Fire TV',
    'Comcast X1',
    'Amazon OS TV',
  ];

  const shouldShowPassportPrompt = (
    stationData !== undefined &&
    !appSignInState.isPassportMember &&
    !PlatformsWithInAppDonation.includes(appSignInState.deviceType as DeviceType)
  );

  return (
    <div className={styles.app_sign_in_success}>
      <div className={styles.app_sign_in_success_content_top}>
        <h2>Success! You are now signed in on your {deviceName}</h2>
        <p>{`You're ready to start watching thousands of hours of content from your favorite PBS shows.`}</p>
      </div>
      <div className={styles.app_sign_in_success_content_bottom}>
        <PassportLockup
          shortCommonName={stationName}
          element={"h4"}
          className={styles.app_sign_in_success_passport_lockup}
        />
      { appSignInState.isPassportMember ? (
        <>
          <p>
            Thank you for being a member! You are supporting America’s largest classroom, the nation’s largest stage for the arts and a trusted window into the world.
          </p>
        </>
      ) : (
        <>
          <p>
            Donate to your local station and enjoy {stationName} Passport as one of many member benefits. Stream with extended access to more of your favorite PBS shows and films using the PBS app.
          </p>
          <a href={passportLearnMoreUrl} className={styles.app_sign_in_success_passport_learn_more}>
            Learn More
          </a>
        </>
      )}
      {shouldShowPassportPrompt && (
        <PassportPrompt stationData={stationData} isOpen={true} />
      )}
      </div>
    </div>
  );
};

export default AppSignInSuccess;
